import { ActionContext } from "vuex"
import Service from "./service"

const getProcessFields = async (
  { commit }: ActionContext<any, any>,
  id: number
) => {
  return await Service()
    .getFieldsBySubProcess(id)
    .then((result: any) => {
      commit("SAVE_FIELDS", result.data)
    })
}

export default {
  getProcessFields,
}
